type HistoryKey=Pick<KeyboardEvent,'key'|'metaKey'|'ctrlKey'|'shiftKey'|'altKey'|'isComposing'|'defaultPrevented'>;
export function historyShortcut(event:HistoryKey):'undo'|'redo'|null{
  if(event.isComposing||event.defaultPrevented||event.altKey||(!event.metaKey&&!event.ctrlKey))return null;
  const key=event.key.toLowerCase();
  if(key==='z')return event.shiftKey?'redo':'undo';
  return key==='y'?'redo':null;
}
